import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { ShoppingBag, Users, Gift, Home, Search } from 'lucide-react';

const BottomNav = () => {
  const location = useLocation();

  if (location.pathname === '/snake') {
    return null;
  }

  return (
    <nav className="fixed bottom-6 left-1/2 -translate-x-1/2 w-[90%] max-w-md h-16 bg-white rounded-full border border-botum-lime flex items-center justify-around px-6 z-50 shadow-[0_10px_30px_rgba(0,0,0,0.1)]">
      <NavLink 
        to="/" 
        className={({ isActive }) => `flex flex-col items-center space-y-1 transition-all duration-300 ${isActive ? 'text-botum-dark scale-110' : 'text-gray-400 hover:text-botum-primary'}`}
      >
        <Home size={22} />
        <span className="text-[10px] font-bold tracking-wide uppercase">Home</span>
      </NavLink>
      
      <NavLink 
        to="/products" 
        className={({ isActive }) => `flex flex-col items-center space-y-1 transition-all duration-300 ${isActive ? 'text-botum-dark scale-110' : 'text-gray-400 hover:text-botum-primary'}`}
      >
        <ShoppingBag size={22} />
        <span className="text-[10px] font-bold tracking-wide uppercase">Shop</span>
      </NavLink>

      <NavLink 
        to="/membership" 
        className={({ isActive }) => `flex flex-col items-center space-y-1 transition-all duration-300 ${isActive ? 'text-botum-dark scale-110' : 'text-gray-400 hover:text-botum-primary'}`}
      >
        <Users size={22} />
        <span className="text-[10px] font-bold tracking-wide uppercase">Points</span>
      </NavLink>

      <NavLink 
        to="/referrals" 
        className={({ isActive }) => `flex flex-col items-center space-y-1 transition-all duration-300 ${isActive ? 'text-botum-dark scale-110' : 'text-gray-400 hover:text-botum-primary'}`}
      >
        <Gift size={22} />
        <span className="text-[10px] font-bold tracking-wide uppercase">Rewards</span>
      </NavLink>

      <NavLink 
        to="/member-search" 
        className={({ isActive }) => `flex flex-col items-center space-y-1 transition-all duration-300 ${isActive ? 'text-botum-dark scale-110' : 'text-gray-400 hover:text-botum-primary'}`}
      >
        <Search size={22} />
        <span className="text-[10px] font-bold tracking-wide uppercase">Members</span>
      </NavLink>
    </nav>
  );
};

export default BottomNav;
